import { Cog, Disc3, Layers, Zap, Filter, Car } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/primitives";

const CATEGORIES = [
  { icon: Cog, label: "Engine" },
  { icon: Disc3, label: "Braking" },
  { icon: Layers, label: "Suspension" },
  { icon: Zap, label: "Electrical" },
  { icon: Filter, label: "Filtration" },
  { icon: Car, label: "Body Parts" },
];

export default function Spares() {
  return (
    <section
      id="spares"
      data-testid="spares-section"
      className="bg-walnut py-20 text-ivory sm:py-28"
    >
      <div className="mx-auto grid max-w-7xl gap-12 px-6 sm:px-10 md:grid-cols-2 md:items-center">
        <div>
          <Reveal>
            <Eyebrow index="07">
              Genuine Parts
            </Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display text-3xl font-extrabold uppercase leading-tight tracking-tight sm:text-4xl lg:text-5xl">
              OEM / OES <span className="gold-text">Spares</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-4 max-w-md text-base font-light leading-relaxed text-ivory/60">
              The right part. The right standard.
            </p>
          </Reveal>
          <Reveal delay={0.3} className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3">
            {CATEGORIES.map((c) => (
              <div
                key={c.label}
                data-testid={`spares-category-${c.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="flex flex-col items-start gap-3 rounded-xl border border-gold/25 bg-white/5 p-4 transition-colors duration-300 hover:border-gold/60"
              >
                <c.icon size={18} strokeWidth={1.5} className="text-gold" />
                <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-ivory/80">
                  {c.label}
                </span>
              </div>
            ))}
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <div className="relative overflow-hidden rounded-2xl">
            <img
              src="/images/spares.webp"
              alt="Organised OEM and OES automotive components at V-Elite Drives"
              loading="lazy"
              className="aspect-[4/3] w-full object-cover md:aspect-[4/5]"
            />
            <div className="absolute inset-0 rounded-2xl border border-gold/20" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
